import React from "react";
import { IIcon } from "./Icon.types";

const SpeedControlIcon: React.FC<IIcon> = ({
  width= "42",
  height= "42",
  fill= "#FFFFFF",
  viewBox= "0 0 32 32",
  onClick,
  className,
}: IIcon): React.JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      stroke={fill}
      viewBox={viewBox}
      onClick={onClick}
      className={className}
      data-testid="speedControlIcon"
    >
      <path
        d="M24.5745 16.7837C25.1418 16.4354 25.1418 15.5646 24.5745 15.2163L16.2766 10.1226C15.7092 9.77429 15 10.2097 15 10.9062L15 21.0938C15 21.7903 15.7092 22.2257 16.2766 21.8774L24.5745 16.7837Z"
        fill="white"
      />
      <path
        d="M16.5745 16.7837C17.1418 16.4354 17.1418 15.5646 16.5745 15.2163L8.27659 10.1226C7.70922 9.77429 7 10.2097 7 10.9062L7 21.0938C7 21.7903 7.70922 22.2257 8.2766 21.8774L16.5745 16.7837Z"
        fill="white"
      />
    </svg>
  );
};

export default SpeedControlIcon;
